import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/public/images/Card/Mobile-Review-Card.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/Card/Review-card.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/Card/Services Card/Accomodation--SIL.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/Card/Services Card/Community-Engagement.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/Card/Services Card/Personal-Inhome-Care.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/Compliances/Compliance-to-31000.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/Compliances/Compliance-to-ISO-20000.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/Compliances/ISO-14001---Environment.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/Compliances/ISO-27001---Information-Security.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/Compliances/ISO-45001-Safety.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/Compliances/ISO-9001---Quality.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/Concierge.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/Create the world we want cards/Image-1.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/Create the world we want cards/Image-2.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/Create the world we want cards/Image-3.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/Create the world we want cards/Image-4.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/Create the world we want cards/Image-5.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/Google-5-star.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/hearts/Build-trust-half-heart.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/hearts/Creating-the-world-we-want-heart.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/hearts/Half-heart-element.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/Image-to-replace-video.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/logo/Incluso Services Logogram-Icon.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/Main-Heart.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/NDIS/We love NDIS logo.png");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/pageSpecific/contact/contactButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_components/section/testimonial/testimonialSlider.tsx");
